export const types = {
  handleFullscreenModalClosing: 'header/handleFullscreenModalClosing',
  handleFullscreenModalOpening: 'header/handleFullscreenModalOpening',
  setHeights: 'header/setHeights',
};

export const getters = {
  getHeights: 'header/getHeights',
  shouldHideExternalBackButton: 'header/shouldHideExternalBackButton',
};

// initial state
const initialState = {
  heights: {
    header: 0,
    headerPlusBanner: 0,
    headerPlusBannerAndSearch: 0,
  },
  numFullscreenModalsOpen: 0,
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    handleFullscreenModalClosing(state) {
      state.numFullscreenModalsOpen -= 1;
    },
    handleFullscreenModalOpening(state) {
      state.numFullscreenModalsOpen += 1;
    },
    setHeights(
      state,
      {
        header = null,
        headerPlusBanner = null,
        headerPlusBannerAndSearch = null,
      },
    ) {
      state.heights = {
        header: header ?? 0,
        headerPlusBanner: headerPlusBanner ?? 0,
        headerPlusBannerAndSearch:
          headerPlusBannerAndSearch ?? headerPlusBanner,
      };
    },
  },
  getters: {
    getHeights(state) {
      return state.heights;
    },
    /**
     * Some Vue pages have an external back button that overlays the header
     * and it hides the main Bimba y Lola logo (ex: PDP). As header is not
     * a vue component, it cannot be the parent and manage those BaseBackButton.
     * Sometimes those back button cannot be overlayed by a modal, because of
     * inherited z-index from ancestors.
     * So, another approach is to have store that flag in Vuex store and hide
     * the button in every component. Although it could be a boolean, the module
     * will better control this condition exporting a getter.
     * In that manner, the module will manage the problem by itself, which has
     * the full knowledge of the conditions: it is a fullscreen modal open,
     * it could be multiple modals...
     *
     * @param {Object} state Model state
     * @returns {boolean}
     */
    shouldHideExternalBackButton(state) {
      return state.numFullscreenModalsOpen > 0;
    },
  },
};
